import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { UiKitModule } from '@ellf/app-ui-kit';
import { LetDirective, PushPipe } from '@ngrx/component';
import { NgrxFormsModule } from 'ngrx-forms';
import { NgrxFormsErrorPipe } from './pipes/ngrx-forms-errors-pipe';

@NgModule({
  imports: [
    CommonModule,
    NgrxFormsModule,
    LetDirective,
    PushPipe,
    ReactiveFormsModule,
    UiKitModule,
  ],
  exports: [
    NgrxFormsModule,
    NgrxFormsErrorPipe,
    LetDirective,
    PushPipe,
    ReactiveFormsModule,
  ],
  declarations: [NgrxFormsErrorPipe],
})
export class AppFormsModule {}
